import { IQuestionById } from '../constants/queryCreation.interface';

export type TAllConceptLabelsAndOutputKeyNames = {
  labels: string[];
  outputKeyNames: string[];
};

export const getAllConceptLabelsAndOutputKeyNames = (
  query: IQuestionById,
  selectedLabel: string,
  selectedOutputKeyName: string
): TAllConceptLabelsAndOutputKeyNames => {
  return Object.keys(query.definition).reduce(
    (acc: TAllConceptLabelsAndOutputKeyNames, curr) => {
      const concept = query.definition[curr];
      let currLabel = concept?.label || '';
      const currOutputCategory = concept.outputCategory || '';
      let update = acc;

      if (currLabel.length === 0 && concept.subQueryId !== null) {
        currLabel = query.subQueries?.[concept.subQueryId || '']?.description || '';
      }

      if (currLabel !== selectedLabel) {
        update = { ...acc, labels: [...acc.labels, currLabel] };
      }

      if (currOutputCategory?.length !== 0 && currOutputCategory !== selectedOutputKeyName) {
        update = { ...update, outputKeyNames: [...acc.outputKeyNames, currOutputCategory] };
      }

      return update;
    },
    { labels: [], outputKeyNames: [] }
  );
};
